// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4531":"css/app.7088","7560":"css/admin-app.7088"}[chunkId] + ".css";
};